import * as d3 from 'd3';
import { ElementRender } from './ElementeRenderer';
import { ItemFormat } from '../interfaces';

export class MinMax extends ElementRender {
    private _triangleSize = 25;

    constructor(selection: d3.Selection<any>) {
        super(selection, 'minmax');
    }

    render(data: ItemFormat[]) {
        const selection = this.container();
        const databound = selection
            .selectAll('g.serie-minmax')
            .data(data);
        databound.exit()
            .remove();

        const enterSelection = databound
            .enter()
            .append('g')
            .classed('serie-minmax', true);

        enterSelection.append('line')
            .classed('center', true)
            .style('fill', 'none');

        const minGroup = enterSelection.append('g')
            .classed('min', true);
        minGroup.append('line')
            .classed('min', true)
            .style('fill', 'none');
        const triangleMin = d3.svg.symbol()
            .type(`triangle-down`)
            .size(this._triangleSize);
        minGroup.append('path')
            .classed('triangle-min', true)
            .attr('d', triangleMin);

        const maxGroup = enterSelection.append('g')
            .classed('max', true);
        maxGroup.append('line')
            .classed('max', true)
            .style('fill', 'none');
        const triangleMax = d3.svg.symbol()
            .type(`triangle-up`)
            .size(this._triangleSize);
        maxGroup.append('path')
            .classed('triangle-max', true)
            .attr('d', triangleMax);
        databound.attr('transform', d => `translate(${d.x + d.width / 2}, ${d.y2})`);
        this.updateMinMax(databound);
    }

    // calculate the half-height ot an equilateral triangle given it's aera
    private halfTriangleHeight(aera: number) {
        return Math.sqrt(3 * aera / Math.sqrt(3)) / 2;
    }

    private updateMinMax(selection: d3.Selection<ItemFormat>) {
        const height = this.halfTriangleHeight(this._triangleSize);
        selection.select('g.min')
            .attr('transform', d => `translate(0, ${d.y1 - d.y2})`)
            .style('visibility', d => d.item.hasMin ? null : 'hidden');
        selection.select('line.min')
            .attr('x1', d => -d.width / 8)
            .attr('x2', d => d.width / 8);
        selection.select('path.triangle-min')
            .attr('transform', `translate(0, ${-height})`)
            .style('visibility', d => d.item.hasMax && d.item.hasMin ? 'hidden' : null);


        const maxGroup = selection.select('g.max')
            .attr('transform', d => `translate(0, 0)`)
            .style('visibility', d => d.item.hasMax ? null : 'hidden');
        maxGroup.select('line.max')
            .attr('x1', d => -d.width / 8)
            .attr('x2', d => d.width / 8);
        maxGroup.select('path.triangle-max')
            .attr('transform', `translate(0, ${height})`)
            .style('visibility', d => d.item.hasMax && d.item.hasMin ? 'hidden' : null);

        selection.select('line.center')
            .attr('y1', 0)
            .attr('y2', d => d.y1 - d.y2)
            .style('visibility', d => d.item.hasMax && d.item.hasMin ? null : 'hidden');
    }
}